export default "__VITE_ASSET__BK23rCVH__"